import IconLoader from "@/features/Common/components/IconLoader";
import { Button } from "@mui/material";
import WellnessCategoryCard from "../WellnessCategoryCard";
import { useTranslation } from "react-i18next";
import {
  WellnessCategoryCardProps,
  WellnessScoreStatus,
} from "../Common/types";

export default function HealthHistoryCard() {
  const { t } = useTranslation();

  const healthHistoryProps: WellnessCategoryCardProps = {
    icon: (
      <IconLoader
        icon="HealthHistoryIcon"
        color="primary"
        sx={{ fontSize: 40 }}
      />
    ),
    title: "Health History",
    status: undefined,
    description: t("HealthHistory.description"),
    lastUpdated: "",
  };

  return (
    <WellnessCategoryCard {...healthHistoryProps}>
      <Button
        variant="contained"
        color="primary"
        onClick={() => console.log("Primary Button Clicked")}
        fullWidth
      >
        {t("HealthHistory.buttonLabel.primary")}
      </Button>
    </WellnessCategoryCard>
  );
}
